export default "__VITE_ASSET__DBCX4vqz__"